import React from "react";
import MaldiveEventsCards from "./MaldiveEventsCards/MaldiveEventsCards.view";
import HeroSection from "./HeroSection/HeroSection.view";
import Register from "./Register/Register";
// import FixedBanner from "./FixedBanner/FixedBanner";
import Footer from "../../Components/Footer/Footer";
import FAQ from "./FAQ/FAQ";
import Navbar from "../../Components/Navbar-copy/Navbar";
import EventsSlider from "./EventsSlider/EventsSlider.view";
import InfiniteCarousel from "./MaldiveEventsCards/ChildComponents/InfiniteCarousel/InfiniteCarousel";

import "./ZixxarMaldiveEvent.style.scss";

const ZixxarMaldiveEvent = () => {
  return (
    <div className="maldive-event-page">
      <Navbar />

      <HeroSection />

      <InfiniteCarousel />

      <EventsSlider />

      <MaldiveEventsCards />

      {/* <Speakers /> */}

      <FAQ />

      <Register />

      <Footer />
      {/* <FixedBanner /> */}
    </div>
  );
};

export default ZixxarMaldiveEvent;
